import { render, staticRenderFns } from "./PageFive.vue?vue&type=template&id=765e61f9&scoped=true"
import script from "./PageFive.vue?vue&type=script&lang=js"
export * from "./PageFive.vue?vue&type=script&lang=js"
import style0 from "./PageFive.vue?vue&type=style&index=0&id=765e61f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e61f9",
  null
  
)

export default component.exports